import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite/dist"
import { useProposalsEditPaymentStore } from "./ProposalsEditPaymentStore"
import { ServiceRateTypeEnum, serviceRateTypeEnumsLabels } from "@gap/backend/app-services/services/models/ServiceRateTypesDto"
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from "theme/useTheme"
import ProposalsEditPaymentPaymentBlock from "./ProposalsEditPaymentPaymentBlock"
import ProposalsEditPaymentServiceBlock from "./service-block-row/ProposalsEditPaymentServiceBlock";
import { notNull } from "@gap/utils/utils";

export default observer(function ProposalsEditPaymentRateTypeBlock({ rateType }: { rateType: ServiceRateTypeEnum }) {
   const proposalEditPaymentStore = useProposalsEditPaymentStore()
   const theme = useTheme()

   if (!proposalEditPaymentStore.stepHasService(rateType)) {
      return null
   }

   return <Paper sx={{
      border: `1px solid ${theme.palette.gap.primary['200']}`,
      mt: 4,
      borderRadius: '24px',
      overflowY: 'hidden',
   }} elevation={0}>
      <Box sx={{ p: 2, pt: 1, height: '50px', backgroundColor: theme.palette.gap.primary['50'], borderBottom: `1px solid ${theme.palette.gap.primary['200']}` }}>
         <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {serviceRateTypeEnumsLabels[rateType]}
         </Typography>
      </Box>
      <Box sx={{ p: 2 }}>
         <Typography variant="body1" sx={{ fontWeight: 'bold', marginBottom: 4 }}>
            Price your services
         </Typography>
         <ServiceList rateType={rateType} />
         <Typography variant="body1" sx={{ fontWeight: 'bold', marginTop: 4 }}>
            Set your payment options
         </Typography>
         <Typography variant="body2" sx={{ marginTop: .5, marginBottom: 3 }}>
            Your client will be able to choose one option from any of the following payment options you enable for this fee type.
         </Typography>

         <Stack sx={{ gap: 1 }}>
            <ProposalsEditPaymentPaymentBlock rateType={rateType} blockType="Monthly instalments over 12-month period" />
            <ProposalsEditPaymentPaymentBlock rateType={rateType} blockType="Annual payment" />
            <ProposalsEditPaymentPaymentBlock rateType={rateType} blockType="Payment on completion" />
            <ProposalsEditPaymentPaymentBlock rateType={rateType} blockType="Upfront payment in full" />
            <ProposalsEditPaymentPaymentBlock rateType={rateType} blockType="Staged payments" />
         </Stack>
      </Box>
   </Paper>
})

const ServiceList = observer(function ServiceList({ rateType }: { rateType: ServiceRateTypeEnum }) {
   const proposalEditPaymentStore = useProposalsEditPaymentStore()
   const stepData = notNull(proposalEditPaymentStore.getStepByRateType(rateType))

   return (
      <Stack sx={{ gap: 6 }}>
         {stepData.services.map(service =>
            <ProposalsEditPaymentServiceBlock step3ServiceId={service.serviceId} rateType={rateType} key={`key-for-service-${service.serviceId}`} />
         )}
      </Stack>
   )
})
